import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { HttpStatusCodes } from 'shared/httpStatus';
import logger from 'shared/logger';
const log = logger().child({
  namespace: 'useBuildId'
});

// eslint-disable-next-line no-process-env
const BUILD_ID = process.env.NEXT_PUBLIC_BUILD_ID as string;
const useBuildId = () => {
  const $ = _c(1);
  const shouldReload = _temp;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      shouldReload
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default useBuildId;
async function _temp() {
  log.info(BUILD_ID);
  if (typeof window !== "undefined" && BUILD_ID != null) {
    ;
    try {
      const response = await fetch(`/_next/static/${BUILD_ID}/_buildManifest.js`, {
        method: "HEAD",
        headers: {
          Pragma: "no-cache",
          "Cache-Control": "no-cache",
          "If-Modified-Since": "Thu, 01 Jun 1970 00:00:00 GMT"
        }
      });
      return response.status === HttpStatusCodes.NOT_FOUND;
    } catch (t0) {
      const error = t0;
      log.warn({
        err: error instanceof Error ? error.message : String(error)
      }, "Could not check build id, skipping reload");
      return false;
    }
  }
  return false;
}